
export class CookiesContext {

    public cookieConsentGiven: boolean = false;
    public cookieConsentBannerVisible: boolean = false;
    public cookieManagementModalVisible: boolean = false;
    public cookieConsentPreferences: Record<string, boolean> = {};

    constructor() {

    }
}